module.exports = __webpack_public_path__ + "img/hy.70ed3892.jpg";